import api from "@utils/api";

/**
 * Obtiene los horarios de reserva disponibles para una fecha y una celda específicas.
 * @param {string} date - La fecha en formato YYYY-MM-DD.
 * @param {string} location - El ID del parqueadero/celda.
 * @returns {Promise<object>} - Una promesa que se resuelve con el objeto de disponibilidad.
 */
export const getAvailabilityByDate = (date, location) => {
  return api.get(`/bookings/availability`, { params: { date, location } });
};

/**
 * Obtiene las celdas de parqueo disponibles para una fecha y hora específicas.
 * @param {string} date - La fecha en formato YYYY-MM-DD.
 * @param {string} time - La hora de inicio en formato HH:MM.
 * @returns {Promise<Array>} - Una promesa que se resuelve con la lista de celdas disponibles.
 */
// export const getAvailableParkers = (date, time) => {
//   return api.get(`/parkers/available`, { params: { date, time } });
// };

/**
 * Crea una nueva reserva.
 * @param {object} bookingData - Los datos de la reserva.
 * @param {number} bookingData.user_id - ID del usuario.
 * @param {number} bookingData.parker_id - ID de la celda de parqueo.
 * @param {string} bookingData.booking_date - Fecha de la reserva (YYYY-MM-DD).
 * @param {string} bookingData.start_time - Hora de inicio (HH:MM).
 * @param {string} bookingData.end_time - Hora de fin (HH:MM).
 * @returns {Promise<object>} - Una promesa que se resuelve con el objeto de la reserva creada.
 */
export const createBooking = (bookingData) => {
  return api.post("/bookings", bookingData);
};

/**
 * Obtiene las reservas de un usuario específico.
 * @param {number} userId - El ID del usuario.
 * @returns {Promise<Array>} - Una promesa que se resuelve con la lista de reservas del usuario.
 */
export const getMyBookings = () => {
  return api.get('/bookings/me');
};

export const getBookingsByPlate = (plate) => {
  return api.get(`/bookings/vehicle/${plate}`);
};
export const getBookingsByVehicleAndDate = (vehicleId, date) => {
  return api.get(`/bookings/vehicle/${vehicleId}/date/${date}`);
};

export const deleteBooking = (bookingId) => {
  return api.delete(`/bookings/${bookingId}`);
};

export const getBookingById = (bookingId) => {
  return api.get(`/bookings/${bookingId}`);
};

export const getSuggestedBookings = () => {
  return api.get('/api/turnos/sugeridos');
};

const reservasService = {
  getAvailabilityByDate,
  // getAvailableParkers,
  createBooking,
  getMyBookings,
  getBookingsByPlate,
  deleteBooking,
  getBookingById,
  getSuggestedBookings,
};

export default reservasService;
